import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export function useMutationDeleteSessionPackSubscriptionBySubscriptionId({
  api,
}: {
  api: ApiType;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      subscriptionId,
    }: {
      subscriptionId: number;
      userMemberId: string;
    }) =>
      (
        await api.memberApi.deleteSessionPackSubscriptionBySubscriptionId(
          subscriptionId,
        )
      ).data,
    onSuccess: async (_, { userMemberId }) => {
      await queryClient.invalidateQueries({
        queryKey:
          memberQueryKeys.userMemberSessionPackSubscriptionCurrent(
            userMemberId,
          ),
      });
      await queryClient.invalidateQueries({
        queryKey:
          memberQueryKeys.userMemberSessionPackSubscriptionPrevious(
            userMemberId,
          ),
      });
    },
  });
}
